var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgReCampaignType = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 18,
    viewBox: "0 0 21 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 0C19.2091 0 21 1.79086 21 4V14C21 16.2091 19.2091 18 17 18H9.5C8.94772 18 8.5 17.5523 8.5 17V13.5C8.5 11.2909 6.70914 9.5 4.5 9.5H2C1.44772 9.5 1 9.05229 1 8.5V4C1 1.79086 2.79086 0 5 0H17ZM6 14.25C6.41421 14.25 6.75 14.5858 6.75 15C6.75 15.4142 6.41421 15.75 6 15.75H1C0.585786 15.75 0.25 15.4142 0.25 15C0.25 14.5858 0.585786 14.25 1 14.25H6ZM6 11.25C6.41421 11.25 6.75 11.5858 6.75 12C6.75 12.4142 6.41421 12.75 6 12.75H1C0.585786 12.75 0.25 12.4142 0.25 12C0.25 11.5858 0.585786 11.25 1 11.25H6ZM17.624 4.58398C17.3943 4.23934 16.9286 4.14621 16.584 4.37598L12.8027 6.89648C11.7111 7.62427 10.2889 7.62427 9.19727 6.89648L5.41602 4.37598C5.07137 4.14621 4.60574 4.23934 4.37598 4.58398C4.14624 4.92863 4.23935 5.39427 4.58398 5.62402L8.36523 8.14453C9.96076 9.20821 12.0392 9.20821 13.6348 8.14453L17.416 5.62402C17.7607 5.39427 17.8538 4.92863 17.624 4.58398Z",
    fill: "#6B7DE5"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgReCampaignType);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/RE_Campaign_type.13ead466d9a79390ff9ed5066413bd18.svg";